import { User } from "@iventis/domain-model/model/user";
import React, { ReactNode } from "react";
import { UseIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { Toasts } from "@iventis/toasts/src/toast.types";
import { CustomDialog, CustomDialogAnchor } from "@iventis/components";
import { UsePeopleViewMachineType } from "./people-view.machine";
import { AddPeople } from "./add-people-to-teams";
import { PeopleApiCallbacks } from "./types";

export const AddPeopleModal: React.FC<{
    title: string | ReactNode;
    open: boolean;
    addPeople: (people: User[]) => void;
    unavailablePersonIds: string[];
    apiCallbacks: Pick<PeopleApiCallbacks, "postNewUserAndGroups" | "getTeams" | "getPeople">;
    className?: string;
    isSubmitting?: boolean;
    machineInstance?: UsePeopleViewMachineType;
    projectId?: string;
    confirmButtonText?: string;
    translate: UseIventisTranslate;
    toast: Toasts;
}> = ({ title, open = true, addPeople, apiCallbacks, unavailablePersonIds, className, machineInstance, projectId, isSubmitting, confirmButtonText, translate, toast }) => (
    <CustomDialog
        anchor={CustomDialogAnchor.TOP}
        open={open}
        maxWidth="md"
        className={className}
        onClose={() => {
            addPeople([]);
        }}
    >
        <AddPeople
            isSubmitting={isSubmitting}
            title={title}
            apiCallbacks={apiCallbacks}
            addPeople={addPeople}
            projectId={projectId}
            unavailablePersonIds={unavailablePersonIds}
            machineInstance={machineInstance}
            confirmButtonText={confirmButtonText}
            toast={toast}
            translate={translate}
        />
    </CustomDialog>
);
